import { render, staticRenderFns } from "./SeoSection.vue?vue&type=template&id=2a28e4dc&"
import script from "./SeoSection.vue?vue&type=script&lang=js&"
export * from "./SeoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports